module.exports = __webpack_public_path__ + "static/media/asset_celebration.d70095b6.svg";